import React, { Fragment, useContext } from 'react';
import { NavLink, Link } from 'react-router-dom';
import {
  DashboardTwoTone,
  CardOutlineTwoTone,
  FolderTwoTone,
  TabletTwoTone,
  SettingsTwoTone,
  TaxesTwoTone,
  AccountDetailsTwoTone,
  PrinterPosTwoTone,
} from 'common/icons';
import { AppTranslationHelper } from 'common/types';
import { appContext } from 'common/contexts/appContext';
import { Routes as R } from 'common/enums';
import styles from './drawer.module.css';

type DrawerProps = { translation: AppTranslationHelper };
type DrawerNavLink = { name: string; to: string; icon: JSX.Element };

const Drawer: React.FC<DrawerProps> = ({ translation }) => {
  const context = useContext(appContext);
  const isAdmin = context?.state?.isAdmin || false;
  const isEditor = context?.state?.isEditor || false;

  // Determinar las opciones de navegación según el rol del usuario
  let nav: DrawerNavLink[] = [];
  
  // Si es editor (pero no admin), mostrar solo la opción "Mis Productos"
  if (isEditor && !isAdmin) {
    nav = [
      { name: translation.t('admin.menu.myProductsLabel', 'Mis Productos'), to: R.AdminItemList, icon: <CardOutlineTwoTone /> },
    ];
  } else {
    // Para administradores y otros roles, mostrar todas las opciones
    nav = [
    { name: translation.t('admin.menu.dashboardLabel'), to: R.AdminDashboard, icon: <DashboardTwoTone /> },
    { name: translation.t('admin.menu.categoriesLabel'), to: R.AdminCategoryList.replace(':id', 'root'), icon: <FolderTwoTone /> },
    { name: translation.t('admin.menu.itemsLabel'), to: R.AdminItemList, icon: <CardOutlineTwoTone /> },
    { name: translation.t('admin.menu.offersLabel', 'Ofertas'), to: R.AdminOfferList, icon: <CardOutlineTwoTone /> },
    { name: translation.t('admin.menu.salesLabel'), to: R.OrdersList, icon: <CardOutlineTwoTone /> },
    { name: translation.t('admin.menu.cashierClosesLabel'), to: R.CashierClosesList, icon: <PrinterPosTwoTone /> },
    { name: translation.t('admin.menu.cashMovementsLabel'), to: '/admin/cash-movements', icon: <CardOutlineTwoTone /> },
    { name: translation.t('admin.menu.taxesLabel'), to: R.AdminTaxList, icon: <TaxesTwoTone /> },
    { name: translation.t('admin.menu.usersLabel'), to: R.AdminUsersList, icon: <AccountDetailsTwoTone /> },
    { name: translation.t('admin.menu.inventoryLabel'), to: R.InventoryItemsList, icon: <CardOutlineTwoTone /> },
    { name: translation.t('admin.menu.settingsLabel'), to: R.AdminSettings, icon: <SettingsTwoTone /> },
    ];
  }

  const renderNavLink = ({ name, to, icon }: DrawerNavLink) => (
    <NavLink
      key={`AdminNavLink_${name}`}
      className={styles.menuItem}
      activeClassName={styles.menuItemActive}
      exact
      to={to}
    >
      <div className={styles.menuIcon}>{icon}</div>
      <div className={styles.menuLabel}>{name}</div>
    </NavLink>
  );

  return (
    <Fragment>
      <div className={styles.root}>
        <div className={styles.head} />
        <div className={styles.body}>{nav.map((entity) => renderNavLink(entity))}</div>
        <div className={styles.foot}>
          <Link className={styles.menuItem} to={R.Terminal}>
            <div className={styles.menuIcon}>
              <TabletTwoTone />
            </div>
            <div className={styles.menuLabel}>{translation.t('admin.menu.terminalLabel')}</div>
          </Link>
        </div>
      </div>
    </Fragment>
  );
};

export default Drawer;
